/** @format */

export const TABLE_HEIGHT = 438;

export const AI_REPORT_STATUS = {
  'success': 'Готово',
  'crafting-report': 'Готовим...',
  'error': 'Ошибка',
};